var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wabident-color-picker"},[_c('compact-picker',{attrs:{"value":_vm.value,"palette":_vm.palette},on:{"input":_vm.updateValue}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }